import BreadCrumbs from '../../../components/common/BreadCrumbs/BreadCrumbs'
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import ManagerDocoumentsList from './ManagerDocumentsList';
import AddPaidDayOff from './AddPaidDayOff';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import Loader from '../../../components/common/Loader';
import ErrorIcon from '../../../../public/assets/images/errorCircleSmall.svg';
import { fetchProfile } from '../../../store/slices/profileSlice';
import Notifications from '../../../components/common/Notifications';
import { trackButtonClick, trackNavigation, trackCustomPageView } from '../../../services/analytics';

const ManageDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const nuidFromState = location.state?.nuid ?? null;
  const [selectedOption, setSelectedOption] = useState<string>('Payday');
  const dispatch = useAppDispatch();
  const profile = useAppSelector((state) => state.profile.profile);
  const profileLoading = useAppSelector((state) => state.profile.loading);
  const profileError = useAppSelector((state) => state.profile.profileError);

  useEffect(() => {
    if (!profile && !profileLoading && !profileError) {
      dispatch(fetchProfile());
    }
  }, [dispatch, profile, profileLoading, profileError]);

  const handleBreadcrumbPrevious = () => {
    console.log('📊 Analytics: Navigate back to manager portal');
    trackNavigation('manager-details', 'manager-portal', 'back');
    trackCustomPageView('manager-portal');
    navigate(`/citizenship/manager-portal`);
  };

  const handleRadioChange = (value: string) => {
    console.log(`📊 Analytics: Manager details option changed - ${value}`);
    trackButtonClick(value === 'viewDetails' ? 'View application details' : 'Add paid day off', 'manager-details-radio');
    value === 'Payday' ? trackCustomPageView('manager-portal:paid-hours') : value === 'viewDetails' ? trackCustomPageView('manager-portal:application-tab') : null;
    setSelectedOption(value);
  };

  if (profileLoading) return <Loader />;

  if (profileError) {
    return (
      <div className="min-h[67vh] lg:px-40! sm:px-5!">
        <Notifications messageInfo={profileError} status={false} />
      </div>
    );
  }

  if (profile && !profile.isManager) {
    return (
      <div className="min-h[67vh] lg:px-40! sm:px-5!">
        <BreadCrumbs
          previousPage="Back to manager portal"
          currentPage=""
          onPreviousClick={handleBreadcrumbPrevious}
        />
        <div className="w-full flex items-center justify-center min-h-[500px]!">
          <div className="w-full max-w-md">
            <div className="flex flex-col items-center text-center">
              <div className="mb-4">
                <img src={ErrorIcon} alt="access denied" className="w-12 h-12 mx-auto" />
              </div>
              <h3 className="h3 text-red-600 mb-2">Access denied</h3>
              <p className="text-gray-700 text-sm">You do not have permission to view this page.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="min-h[67vh] lg:px-40! sm:px-5!">
        <BreadCrumbs
          previousPage="Back to manager portal"
          currentPage=""
          onPreviousClick={handleBreadcrumbPrevious}
        />
        <div>
          <h1 className="h1  pl-3! mt-8!">Manager Details</h1>
        </div>
        <div className="form-group">
          <fieldset className="fieldset mt-8!">
            <legend className="pl-4! lg:pl-0">Select an action</legend>
            <div className="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-6 mt-2">
              <label htmlFor="radio-g-0" className="inline-flex items-center gap-0 pl-8 lg:pl-0 md:order-2 order-1">
                <input
                  className="radio-button relative top-1 left-4"
                  id="radio-g-0"
                  name="radio-group-0"
                  type="radio"
                  value="viewDetails"
                  checked={selectedOption === 'viewDetails'}
                  onChange={() => handleRadioChange('viewDetails')}
                />
                <span className="label-ds2 ml-3">View application details</span>
              </label>

              <label htmlFor="radio-g-1" className="inline-flex items-center gap-0 pl-6 lg:pl-0">
                <input
                  className="radio-button relative top-1 left-4"
                  id="radio-g-1"
                  name="radio-group-0"
                  type="radio"
                  value="Payday"
                  checked={selectedOption === 'Payday'}
                  onChange={() => handleRadioChange('Payday')}
                />
                <span className="label-ds2 ml-3">Add paid day off</span>
              </label>
            </div>
          </fieldset>
        </div>
        <hr className='-variation-1' />
        <div className="margin-top-4u">
          {selectedOption === 'viewDetails' ? (
            <div>
              <ManagerDocoumentsList empNuid={nuidFromState ?? undefined} />
            </div>
          ) : (
            <AddPaidDayOff empNuid={nuidFromState ?? undefined} />
          )}
        </div>
      </div>
    </div>
  );
};

export default ManageDetails;

